require('./database-usage-modal.component.scss');

export class ClickhouseUsageModalController {
  constructor(
    $scope,
    $modalInstance,
    ServerInformationService,
    PermissionService,
  ) {
    $scope.close = () => {
      $modalInstance.close();
    };
    $scope.clickhouseUsage = ServerInformationService.clickhouseUsage;
    $scope.clickhousePath = ServerInformationService.clickhousePath;
    $scope.databaseUsageLimit = PermissionService.databaseUsageLimit;
  }
}



// WEBPACK FOOTER //
// ./src/admin/clickhouse-usage-modal.component.js